import { render } from "./ModalWithdrawOton.vue?vue&type=template&id=4b3bfe00&scoped=true&ts=true"
import script from "./ModalWithdrawOton.vue?vue&type=script&lang=ts"
export * from "./ModalWithdrawOton.vue?vue&type=script&lang=ts"

import "./ModalWithdrawOton.vue?vue&type=style&index=0&id=4b3bfe00&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b3bfe00"]])

export default __exports__